// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-Modal-module__root--2BpAt"};